import React from 'react';

import PopularArticles from '../containers/PopularArticles';
import TopicList from '../containers/TopicList';

const MobileTopicList = () =>
  <div className="mobile-topic-list">
    <PopularArticles />
    <TopicList />
  </div>;

export default MobileTopicList;



// WEBPACK FOOTER //
// ./home/components/MobileTopicList.js